const state = {
    exportData: [],
    exportDataTitle: [],
    exportFileName: "",
    exportExcelFileName: "",
    exportExcelData: [
        // {
        //     sheetName: "1",
        //     title: ['標題1', '標題2', '標題3'],
        //     data: [[data1, data2, data3], [data1, data2, data3]]
        // },
        // {
        //     sheetName: "2",
        //     title: ['標題1', '標題2', '標題3', '標題4'],
        //     data: [[data1, data2, data3, data4], [data1, data2, data3, data4]]
        // }
    ],
};
const getters = {
    get_exportData: state => {
        return state.exportData;
    },
    get_exportDataTitle: state => {
        return state.exportDataTitle;
    },
    get_exportFileName: state => {
        return state.exportFileName;
    },
    get_exportExcelFileName: state => {
        return state.exportExcelFileName;
    },
    get_exportExcelData: state => {
        return state.exportExcelData;
    }
};
const actions = {
    set_exportData(context, data) {
        context.commit("SET_EXPORTDATA", data);
    },
    set_exportDataTitle(context, data) {
        context.commit("SET_EXPORTDATATITLE", data);
    },
    set_exportFileName(context, data) {
        context.commit("SET_EXPORTFILENAME", data);
    },
    set_exportExcelFileName(context, data) {
        context.commit("SET_EXPORTEXCELFILENAME", data);
    },
    set_exportExcelData(context, data) {
        context.commit("SET_EXPORTEXCELDATA", data);
    }
};
const mutations = {
    SET_EXPORTDATA(state, data) {
        state.exportData = data;
    },
    SET_EXPORTDATATITLE(state, data) {
        state.exportDataTitle = data;
    },
    SET_EXPORTFILENAME(state, data) {
        state.exportFileName = data;
    },
    SET_EXPORTEXCELFILENAME(state, data) {
        state.exportExcelFileName = data;
    },
    SET_EXPORTEXCELDATA(state, data) {
        state.exportExcelData = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/exportCsv.js